export const apiConfig = {
  gSearch: {
    autocompleteUrl: `${window.GO_API_URL}/global-search-alt`,
    url: `${window.GO_API_URL}/global-search`,
  },
}
